import { IAutoMapper } from "../core/automapper/interfaces";
import { StringHelper } from "../utilities/contracts/string-helper";

export const mapUserToken = (automapper: IAutoMapper): void => {

  automapper
    .createMap("default", "UserToken")
    .forMember("token", o => o.token)
    .forMember("userId", o => o.userId)
    .forMember("username", o => o.userName)
    .forMember("userOnboardingUrl", o => o.userOnboardingUrl)
    .forMember("directoryRoleIds", o => o.directoryRoleIds)
    .forMember("functionalRoleIds", o => o.functionalRoleIds)
    .forMember("homePageUrl", o => o.homePageUrl)
    .forMember("defaultRole", o => o.defaultRole)
    .forMember("organizationId", o => o.organizationId)
    .forMember("organizationName", o => o.organizationName)
    .forMember("isTemporaryPassword", o => o.isTemporaryPassword)
    .forMember("isManagerRole", o => o.isManagerRole)
    .forMember("isAdminRole", o => o.isAdminRole)
    .forMember("isLeadRole", o => o.isLeadRole)
    .forMember("isMFAEnabled", o => o.isMFAEnabled)
    .forMember("emailAddress", o => o.emailAddress)
    .forMember("phoneNumber", o => o.phoneNumber)
    .forMember("concordFaxUserName", o => o.concordFaxUserName)
    .forMember("firstName", o => o.firstName)
    .forMember("lastName", o => o.lastName)
    .forMember("superAdminMenu", o => o.superAdminMenu);
};

export class UserToken {
  readonly token: string;
  userId: number;
  username: string;
  userOnboardingUrl: string;
  directoryRoleIds: number[];
  functionalRoleIds: number[];
  homePageUrl: string;
  defaultRole: string;
  organizationId: number;
  organizationName: string;
  isTemporaryPassword: boolean;
  isManagerRole: boolean;
  isAdminRole: boolean;
  isLeadRole: boolean;
  isMFAEnabled: boolean;
  emailAddress: string;
  phoneNumber: string;
  concordFaxUserName: string;
  firstName: string;
  lastName: string;
  superAdminMenu: string[];

  constructor(options: {
    token?: string;
    userId?: number;
    username?: string;
    userOnboardingUrl?: string;
    directoryRoleIds?: number[];
    functionalRoleIds?: number[];
    homePageUrl?: string;
    defaultRole?: string;
    organizationId?: number;
    organizationName?: string;
    isTemporaryPassword?: boolean;
    isManagerRole?: boolean;
    isAdminRole?: boolean;
    isLeadRole?: boolean;
    isMFAEnabled?: boolean;
    emailAddress?: string;
    phoneNumber?: string;
    concordFaxUserName?: string;
    firstName?: string;
    lastName?: string;
    superAdminMenu?: string[];
  } = {}) {
    this.token = options.token;
    this.userId = options.userId;
    this.username = StringHelper.clean(options.username);
    this.userOnboardingUrl = StringHelper.clean(options.userOnboardingUrl);
    this.directoryRoleIds = options.directoryRoleIds;
    this.functionalRoleIds = options.functionalRoleIds;
    this.homePageUrl = options.homePageUrl;
    this.defaultRole = options.defaultRole;
    this.organizationId = options.organizationId;
    this.organizationName = options.organizationName;
    this.isTemporaryPassword = options.isTemporaryPassword;
    this.isManagerRole = options.isManagerRole;
    this.isAdminRole = options.isAdminRole;
    this.isLeadRole = options.isLeadRole;
    this.isMFAEnabled = options.isMFAEnabled;
    this.emailAddress = options.emailAddress;
    this.phoneNumber = options.phoneNumber;
    this.concordFaxUserName = options.concordFaxUserName;
    this.firstName = options.firstName;
    this.lastName = options.lastName;
    this.superAdminMenu = options.superAdminMenu;
  }

  get isAuthenticated(): boolean {
    return StringHelper.isAvailable(this.username);
  }
}
